import { Component, OnInit, AfterViewInit, HostListener, ElementRef, ChangeDetectorRef, ViewChild, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MycontentserviceService } from 'src/app/_service/mycontentservice.service';
import { URLS } from '../../constants/URLS';
import { UserchannelService } from '../../_service/userchannel.service';
import { CategoryService } from 'src/app/_service/category.service';
import { HttpClient } from '@angular/common/http';
import { AuthenticateserviceService } from 'src/app/_service/authenticateservice.service';
import { WalletinfoService } from 'src/app/_service/walletinfo.service';
import { environment } from 'src/environments/environment';
import { filter, takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { Region, TVNavigationService } from 'src/app/_service/tv-navigation.service';
import { DeviceService } from 'src/app/_service/tv-detect.service';
import { TVFocusMemoryService } from 'src/app/_service/tv-focus-memory.service';
import { AdResolverService } from 'src/app/_service/ad-resolver.service';
import { AD_CONFIG } from 'src/app/constants/ad-config';
import { NATIVE_ADS } from 'src/app/constants/native-ads.config';

declare let window:any;

@Component({
  selector: 'app-user-channel',
  templateUrl: './user-channel.component.html',
  styleUrls: ['./user-channel.component.css']
})
export class UserChannelComponent implements OnInit, OnDestroy, AfterViewInit {

  channelId: String;
  category:string;
  data: any[];
  sections: any[];
  ccPrime:any[];
  mediaUrl: String = URLS.BASE_URL; 
  channelUrl: String = URLS.channelUrl;
  isLoading: boolean = false;
  channelData:any;
  isUserFollowed:boolean;
  userId:string;
  videos:any;
  videoCount:any;
  contents:any;
  hasReachedEnd: boolean = false;
  firstIndex:number = 0;
  lastIndex:number = 20;
  isCLoading:boolean = false;
  isPLoading:boolean = false;
  startingPlan:any = null;

  // ---- ads ------------------------------------------------------------------

  /** Sections that actually paint a carousel. Ad slots are keyed on THIS index:
      an empty section still renders its container, so keying on the raw index
      drops ads into invisible rows and stacks them on each other. Unlike the
      home feed there is no separate banner loop here, so only emptiness is
      filtered — a banner-template section still renders as a normal carousel. */
  displaySections:any[] = [];

  /** Single source of truth for the ad breakpoint. `isMobile()` reads the live
      window width, so it must not be cached at construction. */
  isMobileView = false;

  get adConfig(): any {
    return this.isMobileView ? AD_CONFIG.mobile.banner : AD_CONFIG.desktop.leaderboard;
  }

  /** Native ads are mobile-only; desktop gets a banner in that slot instead. */
  get nativeAd(): any {
    return this.isMobileView ? NATIVE_ADS.primary : null;
  }

  /** Angular only runs change detection on resize if something listens, so this
      handler is what makes the getters above re-evaluate. */
  @HostListener('window:resize')
  onWindowResize(): void {
    const mobile = this.deviceService.isMobile();
    if (mobile !== this.isMobileView) {
      this.isMobileView = mobile;
      this.cdr.markForCheck();
    }
  }

  private hasContent(section: any): boolean {
    return !!section?.category_data?.length;
  }

  /** Single write path for `sections`, so `displaySections` can never drift. */
  private setSections(list: any[]): void {
    this.sections = list || [];
    this.displaySections = this.sections.filter(s => this.hasContent(s));
  }

  @ViewChild('bannerButton', {static:false}) bannerButton?: ElementRef;
  private readonly bannerRegionId = 'channel-banner';
  private bannerRegistered = false;
  private bannerRetryTimeout?: ReturnType<typeof setTimeout>;
  private destroyed = false;
  private destroy$ = new Subject<void>();
  private componentRoute: string = '';
  private pendingFocusRestore:any = null;

  constructor(
    private authService:AuthenticateserviceService, 
    private http:HttpClient, 
    private route: ActivatedRoute, 
    private userChannel: UserchannelService, 
    private mycontentService: MycontentserviceService, 
    private router: Router, 
    private categService:CategoryService,
    private el: ElementRef,
    private walletService: WalletinfoService,
    private cdr: ChangeDetectorRef,
    private tvNavService: TVNavigationService,
    private deviceService: DeviceService,
    private focusMemory: TVFocusMemoryService,
    public adResolver: AdResolverService,
    ) {
      this.isMobileView = this.deviceService.isMobile();
    }

  ngOnInit() {
    this.userId = localStorage.getItem('userId');
    this.route?.queryParams.subscribe(params => {
      this.channelId = params['channelId'];
      this.category = params['category'];
      this.getChannelDetails();
      if(this.category === 'CC_PRIME'){
        this.getCcPrimeChannelVideos();
        this.el.nativeElement.addEventListener('scroll', this.onScroll.bind(this));
      }else if(this.category === 'PRIME'){
        this.getChannelOfUser();
      }else{
        this.setSections([]);
        this.ccPrime = [];
      }
    });
    console.log(this.category)
    if(this.deviceService.isTV()){
      this.componentRoute = this.router.url;
      this.pendingFocusRestore = this.focusMemory.restoreFocusPosition(this.router.url);

      if(this.pendingFocusRestore){
        this.tvNavService.setPendingRestore(true);
        setTimeout(()=> this.tvNavService.setPendingRestore(false), 5000);

        const targetId = this.pendingFocusRestore.regionId;
        this.tvNavService.regionRegistered$
        .pipe(
          filter(id => id === targetId && this.pendingFocusRestore !==null),
          takeUntil(this.destroy$),
        ).subscribe(()=> {
          if(this.pendingFocusRestore){
            this.tvNavService.activateRegion(
              this.pendingFocusRestore.regionId,
              this.pendingFocusRestore.index
            );
            this.pendingFocusRestore = null;
            this.tvNavService.setPendingRestore(false);
          }
        });
      }

      this.tvNavService.focus$
      .pipe(takeUntil(this.destroy$))
      .subscribe(focusKey => {
        if(!focusKey) return;
        if(this.pendingFocusRestore) return;
        const regionId = this.tvNavService.getActiveRegionId();
        const index = this.tvNavService.getFocusedIndex();
        if(regionId && !regionId.includes('sidebar') && !regionId.startsWith('channel-banner')){
          this.focusMemory.saveFocusPosition({
            regionId,
            index,
            timestamp:Date.now(),
            route: this.componentRoute
          });
        }
      });
    }
  }

  ngAfterViewInit(): void{
    if(!this.deviceService.isTV()) return;
    this.tryRegisterBanner();
  }

  private tryRegisterBanner(attempts:number = 10): void{
    if(this.destroyed || this.bannerRegistered || !this.deviceService.isTV()) return;
    if(this.bannerButton?.nativeElement){
      const region: Region = {
        id: this.bannerRegionId,
        type: 'banner',
        elementRef: this.bannerButton,
        focusableItems: [this.bannerButton]
      };
      this.tvNavService.registerRegion(region);
      this.bannerRegistered = true;
      return;
    }
    if(attempts > 0){
      this.bannerRetryTimeout = setTimeout(() => this.tryRegisterBanner(attempts - 1), 200);
    }
  }

  ngOnDestroy(): void {
    if(this.category === 'CC_PRIME'){
      this.el.nativeElement.removeEventListener('scroll', this.onScroll.bind(this));
    }
    this.destroyed = true;
    this.destroy$.next();
    this.destroy$.complete();
    if(this.bannerRetryTimeout){
      clearTimeout(this.bannerRetryTimeout);
      this.bannerRetryTimeout = undefined;
    }
    if(this.bannerRegistered){
      this.tvNavService.unregisterRegion(this.bannerRegionId);
      this.bannerRegistered = false;
    }
  }

  getEnglishText(section: any): string {
    const enText = section.section_language_text?.find(lang => lang.lang_id === 'en_US');
    return enText?.lang_text || '';
  }
  
  followUnfollowChannel(channel: any) {
    this.http.post(`${URLS.followTimeLineUser}?tqr_user_id=${this.userId}&channel_id=${channel.channelId}&mute=${channel.isUserFollowedChannel}`, {}).subscribe((result: any) => {
      console.log(result);
      if (result.message == 'success') {
        console.log('Channel followed/unfollowed successfully');
        channel.isUserFollowedChannel = !channel.isUserFollowedChannel;
        this.categService.getChannelInfoByUserId().subscribe((result)=>{
          console.log(result);
          this.isLoading = false;
          localStorage.removeItem('channelData');
          localStorage.setItem('channelData', JSON.stringify(result));
        },(error)=>{
          this.isLoading = false;
        })
      } else {
        console.error('Failed to follow/unfollow channel');
      }
    });
  }

  getChannelDetails(){
    this.categService.channelData(this.channelId).subscribe((result: any) => {
      if (result.responseCode === 200) {
        this.channelData = result.responseDto[0];
        this.startingPlan = result.responseDto[0]?.availableSubscriptionPlans[0]?.options[0];
      }
    });
  }

  showPlansModal(){
    this.router.navigate(['/channelplans'], {
      queryParams:{
        channelId: this.channelId,
        channelName: this.channelData?.name,
        vidLibId: this.channelData?.vidLibId
      }
    })
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(event: any): void {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const totalHeight = document.documentElement.scrollHeight || document.body.scrollHeight || 0;
    const windowHeight = document.documentElement.clientHeight || document.body.clientHeight || 0;
  
    const threshold = 200; 
    if (scrollPosition + windowHeight >= totalHeight - threshold && !this.isLoading && !this.hasReachedEnd && this.category!=='PRIME') {
      this.getMoreCcPrimeChannelVideos(this.firstIndex + 20, this.lastIndex + 20);
    }
  }

  getCcPrimeChannelVideos(): void {
    this.isCLoading = true;
    this.cdr.detectChanges();
    forkJoin({
      videos: this.userChannel.getCcPrimeChannelByUserId(this.channelId, this.firstIndex, this.lastIndex),
      watchlist: this.mycontentService.getWatchListOfUser(this.userId)
    })
      .subscribe({
        next: ({ videos, watchlist }) => {
          this.videoCount = videos?.videoCount || 0;
          const data = videos?.data || [];
          this.contents = data;
          this.videos = this.mapVideos(data).map(video => ({
            ...video,
            isInWatchList: watchlist.some((wlitem: any) => wlitem.vidLibId === video.vidLibId)
          }));
          if (data.length > 0) {
            this.category = data[0].category;
          }
          this.mapDownloadContent();
          this.isCLoading = false;
          this.cdr.detectChanges();
        },
        error: (error) => {
          console.error('Error fetching CC_PRIME videos:', error);
          this.isCLoading = false;
          this.cdr.detectChanges();
        }
      });
  }

  getMoreCcPrimeChannelVideos(firstIndex: number, lastIndex: number): void {
    if (this.isCLoading || this.contents?.length >= this.videoCount) {
      this.hasReachedEnd = this.contents?.length >= this.videoCount;
      return;
    }
    this.isCLoading = true;
    this.firstIndex = firstIndex;
    this.lastIndex = lastIndex;
    this.cdr.detectChanges();
    forkJoin({
      videos: this.userChannel.getCcPrimeChannelByUserId(this.channelId, firstIndex, lastIndex),
      watchlist: this.mycontentService.getWatchListOfUser(this.userId)
    })
      .subscribe({
        next: ({ videos, watchlist }) => {
          const data = videos?.data || [];
          this.contents = [...this.contents, ...data];
          this.videos = [
            ...this.videos,
            ...this.mapVideos(data).map(video => ({
              ...video,
              isInWatchList: watchlist.some((wlitem: any) => wlitem.vidLibId === video.vidLibId)
            }))
          ];
          this.isCLoading = false;
          this.hasReachedEnd = this.contents.length >= this.videoCount;
          this.cdr.detectChanges();
        },
        error: (error) => {
          console.error('Error fetching more CC_PRIME videos:', error);
          this.isCLoading = false;
          this.cdr.detectChanges();
        }
      });
  }

  private mapVideos(data: any[]): any[] {
    return data.map((item: any) => {
      const modifiedDate = this.authService.calculateModifiedDate(item.uploadedTime);
      const duration = item.videoDuration.startsWith('00:') ? item.videoDuration.slice(3) : item.videoDuration;
      return {
        ...item,
        modifiedDate,
        isPlaying: false,
        videoCategory: 'ccPrime',
        videoDuration: duration
      };
    });
  }

  getChannelOfUser() {
    this.isPLoading = true;
    this.cdr.detectChanges();
    forkJoin({
      sections: this.userChannel.getChannelByUserId(this.channelId),
      subscriptions: this.walletService.getUserSubscriptions(),
      watchlist: this.mycontentService.getWatchListOfUser(this.userId),
      watchHistory: this.mycontentService.getUserWatchHistory()
    })
      .subscribe({
        next: ({ sections, subscriptions, watchlist, watchHistory }) => {
          this.setSections(sections.map((section: any) => {
            this.transformData(section);
            return section;
          }));

          watchHistory.forEach((movie) => {
            this.mycontentService.transformData(movie);
          })

          this.mapwatchContent(watchlist);
          this.mapSubscription(subscriptions);
          this.mapwatchHistory(watchHistory);
          const channelSubs = subscriptions.filter(s => s.channelId === this.channelData.channelId);
          if(channelSubs.length > 0){
            const latestSub = channelSubs[channelSubs.length - 1];
            this.channelData.isChannelSubscribed = true;
            this.channelData.dateOfExpiry = latestSub.dateOfExpiry;
          }else{
            this.channelData.isChannelSubscribed = false;
          }
          this.isPLoading = false;
          this.cdr.detectChanges();
          console.log(this.sections)
        },
        error: (error) => {
          console.error('Error fetching PRIME channel data:', error);
          this.isPLoading = false;
          this.cdr.detectChanges();
        }
      });
  }

  mapwatchContent(watchresult: any[]) {
    this.sections.forEach(section => {
      section.category_data.forEach(category => {
        category.isInWatchList = watchresult.some(wlitem => category.vidLibId === wlitem.vidLibId);
      });
    });
  }

  mapwatchHistory(watchHistory: any[]) {
    this.sections.forEach(section => {
      section.category_data.forEach(category => {
        const whitem = watchHistory.find(item => item.vidLibId === category.vidLibId);
        if (whitem) {
          category.watchedPercentage = whitem.watchedPercentage;
        }
      });
    });
  }
  
  mapSubscription(subscriptions: any[]) {
    this.sections.forEach(section => {
      section.category_data.forEach(category => {
        category.expiringDate = '';
        subscriptions.forEach(sitem => {
          if (category.channelId == sitem.channelId && sitem.isActive) {
            category.isChannelSubscribed = true;
            category.expiringDate = sitem.dateOfExpiry;
          }
          if (category.vidLibId == sitem.vidLibId && sitem.isActive) {
            category.isPPVSubscribed = true;
            category.expiringDate = sitem.dateOfExpiry;
          }
        });
      });
    });
  }


  transformData(data){
    for(const category of data.category_data){
      this.mycontentService.transformData(category)
    }
  }

  async listContent() {
    return await window.storage?.list();
  }

  async mapDownloadContent() {
    try {
      const downloadResult = await this.listContent();
      const downloadedVideoMap = new Map();
      downloadResult.forEach(dlitem => {
        downloadedVideoMap.set(dlitem.vidLibId, true);
      });
      this.videos.forEach(section => {
        section.isDownloaded = downloadedVideoMap.has(section.vidLibId);
      });
    } catch (error) {
      console.error('Error mapping download content:', error);
    }
  }

  onCategoryClick(name: string, id: string, count:number){
    this.router.navigate([`/browse/section/${id}/${name}`],{
      queryParams:{
        count: count
      }
    })
  }

  onBannerError(event: any) {
    event.target.src = './assets/img/LOGIN_bg.png';
  }

  onAvatorError(event: any) {
    event.target.src = './assets/logos/TOQQER_ORIGINALS.svg';
  }
}